module.exports = __webpack_public_path__ + "static/media/img_fenlei04.31ed1523.png";